import { Alert, Box, Typography } from "@mui/material";
import { Users } from "lucide-react";
import {
  Create,
  Datagrid,
  DateField,
  Edit,
  List,
  SimpleForm,
  TextField,
  TextInput,
  required,
  useRecordContext,
} from "react-admin";
import { EditorToolbar } from "../../components";
import { AceInput, bulkEmailResources } from "./common";

function SegmentList() {
  return (
    <List sort={{ field: "id", order: "DESC" }} perPage={50}>
      <Datagrid rowClick="edit">
        <TextField source="id" />
        <TextField source="name" />
        <TextField source="description" />
        <DateField source="updated_at" showTime />
      </Datagrid>
    </List>
  );
}

function SegmentFields() {
  return (
    <>
      <TextInput source="name" fullWidth validate={required()} />
      <TextInput source="description" fullWidth multiline minRows={2} />
      <AceInput
        source="sql_query"
        label="ClickHouse SELECT / WITH query"
        mode="sql"
        defaultValue="SELECT email FROM ..."
        validate={required()}
      />
    </>
  );
}

function SegmentValidation() {
  const record = useRecordContext();
  const validation = record?.latest_validation;
  const assignment = validation?.summary?.assignments?.find(
    (item) => item.segment_id === record.id,
  );
  if (!validation) return null;

  return (
    <Box sx={{ width: "100%", mt: 2 }}>
      <Alert severity={validation.status === "success" ? "success" : "error"}>
        Last validated {validation.completed_at || validation.created_at}:{" "}
        {validation.status}
      </Alert>
      {(validation.errors || []).map((error, index) => (
        <Alert severity="error" key={index}>
          {error.code}: {error.message || error.count}
        </Alert>
      ))}
      {assignment && (
        <Box sx={{ mt: 2 }}>
          <Typography>
            Raw {assignment.raw}, suppressed {assignment.suppressed},
            overlapping {assignment.overlapping}, effective{" "}
            {assignment.effective}
          </Typography>
          <Typography>Columns: {assignment.columns.join(", ")}</Typography>
          <pre>{JSON.stringify(assignment.sample_rows, null, 2)}</pre>
        </Box>
      )}
    </Box>
  );
}

function SegmentCreate() {
  return (
    <Create redirect="edit" mutationMode="pessimistic">
      <SimpleForm>
        <SegmentFields />
      </SimpleForm>
    </Create>
  );
}

function SegmentEdit() {
  return (
    <Edit mutationMode="pessimistic">
      <SimpleForm toolbar={<EditorToolbar showDelete />}>
        <SegmentFields />
        <SegmentValidation />
      </SimpleForm>
    </Edit>
  );
}

export const BulkEmailSegments = {
  category: "email",
  name: bulkEmailResources.segments,
  list: SegmentList,
  create: SegmentCreate,
  edit: SegmentEdit,
  icon: Users,
  roles: ["administrator"],
  options: { label: "Email Segments" },
};
